import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getTagConfig } from "../lib/analytics";

// SEO runtime: canonical di produzione su ogni rotta, meta verifica Search Console
// (quando GOOGLE_SITE_VERIFICATION è configurato), noindex fuori dal dominio di
// produzione (preview/staging esclusi dall'indicizzazione Google).
export const SeoRuntime = () => {
  const location = useLocation();

  useEffect(() => {
    let alive = true;
    getTagConfig().then((cfg) => {
      if (!alive) return;
      const siteUrl = (cfg.siteUrl || "").replace(/\/$/, "");
      if (siteUrl) {
        let link = document.querySelector('link[rel="canonical"]');
        if (!link) {
          link = document.createElement("link");
          link.rel = "canonical";
          document.head.appendChild(link);
        }
        // normalizzazione: niente trailing slash, /categoria/:slug → top-level
        let path = location.pathname.replace(/\/+$/, "") || "/";
        if (path.startsWith("/categoria/")) path = path.slice("/categoria".length);
        link.href = siteUrl + path;
        try {
          const prodHost = new URL(siteUrl).hostname;
          if (window.location.hostname !== prodHost && !document.querySelector('meta[name="robots"]')) {
            const m = document.createElement("meta");
            m.name = "robots";
            m.content = "noindex, nofollow";
            document.head.appendChild(m);
          }
        } catch { /* siteUrl non valido */ }
      }
      if (cfg.googleSiteVerification && !document.querySelector('meta[name="google-site-verification"]')) {
        const m = document.createElement("meta");
        m.name = "google-site-verification";
        m.content = cfg.googleSiteVerification;
        document.head.appendChild(m);
      }
      // Google Business Profile: link configurato → entra nel grafo schema.org (sameAs)
      if (cfg.googleBusinessUrl) {
        const el = document.getElementById("flash-local-business");
        if (el) {
          try {
            const data = JSON.parse(el.textContent);
            data.sameAs = [cfg.googleBusinessUrl];
            el.textContent = JSON.stringify(data);
          } catch { /* JSON-LD non valido */ }
        }
      }
    });
    return () => { alive = false; };
  }, [location.pathname]);

  return null;
};

export default SeoRuntime;
